// 画像から読み込む（2026-10-21 に app.js から分けた）
import { S } from './state.js';
import { txt } from './text.js';
import { catByKey } from './store.js';
import { findPart } from './core/data.js';
import { loadSave as applySave } from './loadsave.js';
import { unzip } from './core/zlib.js';
import { readEmbeddedText } from './core/embed.js';
import { selectCategory } from './categories.js';
import { pop } from './parts.js';
import { histCut, snapshot, toast } from './history.js';
import { closeModal } from './dialog.js';
import type { SaveData } from './types.js';
// ---- 画像から読み込む ----
// ダウンロードした画像には、左上の画素から順に「[START] + base64(保存データの圧縮した文字) + [END]」が入っている
// （埋め込み・読み方は core/embed.ts。additional.js の画像DL・高画質DL、この画面の downloadFinished が入れる。genesis2/restore.php なども同じ決まり）。
// CHOCO のキャラかどうかは、行のカテゴリとパーツが CHOCO にあるかで見る（6 割以上・3 行以上）。違えば 'other'、データが無ければ null
export function readEmbedded(f: Blob) {
  return new Promise<SaveData | 'other' | null>((resolve) => {
    const url = URL.createObjectURL(f), img = new Image();
    img.onload = () => {
      const text = readEmbeddedText(img);
      URL.revokeObjectURL(url);
      if (text === null) return resolve(null); // 頭が違う・終わりが無い＝データの無い画像
      let z = null;
      try { z = decodeURIComponent(escape(atob(text))); } catch (e) { return resolve(null); }
      unzip(z).then((t) => JSON.parse(t)).then((save: SaveData | null) => {
        if (!save || !Array.isArray(save.c)) return resolve(null);
        const good = save.c.filter((line) => {
          const cols = String(line).split(','), cat = catByKey[cols[0]];
          return cat && findPart(cat, cols[1]);
        }).length;
        resolve(good >= 3 && good >= save.c.length * 0.6 ? save : 'other');
      }, () => resolve(null));
    };
    img.onerror = () => { URL.revokeObjectURL(url); resolve(null); };
    img.src = url;
  });
}
// キャラを読み込んで閉じ、「元に戻す」付きのお知らせ（確認は出さない。ランダム・プリセットと同じ）
export function loadCharacter(save: SaveData, label: string) {
  histCut();
  const snap = snapshot();
  applySave(save);
  closeModal();
  selectCategory(S.selKey);
  pop();
  toast(txt('loaded', { label: label }), snap);
}
